// import React, { useState, useEffect, useRef } from 'react';
// import { QRCodeCanvas } from 'qrcode.react'; // Updated import
// import html2canvas from 'html2canvas';
// import axios from 'axios';

// const DigitalIDCard = () => {
//   const cardRef = useRef(null);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch user data based on email from localStorage
//   useEffect(() => {
//     const email = localStorage.getItem('email');
//     if (!email) {
//       setError('No email found in localStorage');
//       setLoading(false);
//       return;
//     }

//     axios
//       .get(`${process.env.REACT_APP_API_URL}jobseeker/by-email/${email}`)
//       .then((response) => {
//         const uniqueNumber = response.data.uniqueNumber;
//         if (!uniqueNumber) {
//           setError('User has no unique number');
//           setLoading(false);
//           return;
//         }

//         axios
//           .get(`${process.env.REACT_APP_API_URL}jobseeker/user/${uniqueNumber}`)
//           .then((response) => {
//             setUser(response.data);
//             setLoading(false);
//           })
//           .catch((err) => {
//             setError('Failed to load user data');
//             setLoading(false);
//           });
//       })
//       .catch((err) => {
//         setError('Failed to find user by email');
//         setLoading(false);
//       });
//   }, []);

//   const calculateAge = (dob) => {
//     if (!dob) return 'N/A';
//     const birthDate = new Date(dob);
//     const ageDifMs = Date.now() - birthDate.getTime();
//     const ageDate = new Date(ageDifMs);
//     return Math.abs(ageDate.getUTCFullYear() - 1970);
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleDownload = () => {
//     if (!user) return;
//     html2canvas(cardRef.current).then((canvas) => {
//       const link = document.createElement('a');
//       link.download = `${user.firstName}_${user.lastName}_IDCard.png`;
//       link.href = canvas.toDataURL('image/png');
//       link.click();
//     });
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;
//   if (!user) return <div>No user data available</div>;

//   const age = calculateAge(user.dateOfBirth);
//   const stateOfOrigin = user.state || 'N/A';
//   const profilePicture = user.avatar || 'https://via.placeholder.com/150';
//   const profession = user.job || user.handworkSkill || 'N/A';
//   const dateCreated = user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A';
//   const tin = user.TIN || 'N/A';
//   const uniqueNumber = user.uniqueNumber;

//   return (
//     <div className="flex flex-col items-center p-4">
//       <div
//         ref={cardRef}
//         className="w-96 bg-white shadow-lg rounded-lg overflow-hidden border-2 border-blue-500 p-4"
//       >
//         <div className="bg-blue-500 text-white text-center py-2">
//           <h2 className="text-xl font-bold">EJOB ID Card</h2>
//         </div>
//         <div className="flex flex-col items-center mt-4">
//           <img
//             src={profilePicture}
//             alt="Profile"
//             className="w-24 h-24 rounded-full border-2 border-blue-500 object-cover"
//           />
//           <h3 className="text-lg font-semibold mt-2">
//             {user.firstName} {user.lastName}
//           </h3>
//           <p className="text-sm text-gray-600">{profession}</p>
//         </div>
//         <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
//           <div>
//             <span className="font-bold">Age:</span> {age}
//           </div>
//           <div>
//             <span className="font-bold">Gender:</span> {user.gender || 'N/A'}
//           </div>
//           <div>
//             <span className="font-bold">State of Origin:</span> {stateOfOrigin}
//           </div>
//           <div>
//             <span className="font-bold">TIN:</span> {tin}
//           </div>
//           <div className="col-span-2">
//             <span className="font-bold">Unique Number:</span> {uniqueNumber}
//           </div>
//           <div className="col-span-2">
//             <span className="font-bold">Date Created:</span> {dateCreated}
//           </div>
//         </div>
//         <div className="mt-4 flex justify-center">
//           <QRCodeCanvas value={uniqueNumber} size={128} /> {/* Updated to QRCodeCanvas */}
//         </div>
//         <div className="text-center text-xs text-gray-500 mt-4">
//           Scan QR for details
//         </div>
//       </div>
//       <div className="mt-4 flex space-x-4">
//         <button
//           onClick={handlePrint}
//           className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//         >
//           Print ID Card
//         </button>
//         <button
//           onClick={handleDownload}
//           className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
//         >
//           Download ID Card
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DigitalIDCard;





import React, { useState, useEffect, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import axios from 'axios';

const DigitalIDCard = () => {
  const cardRef = useRef(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch user data based on email from localStorage
  useEffect(() => {
    const email = localStorage.getItem('email');
    if (!email) {
      setError('No email found in localStorage');
      setLoading(false);
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}jobseeker/by-email/${email}`)
      .then((response) => {
        const uniqueNumber = response.data.uniqueNumber;
        if (!uniqueNumber) {
          setError('User has no unique number');
          setLoading(false);
          return;
        }

        // Fetch comprehensive user data
        axios
          .get(`${process.env.REACT_APP_API_URL}jobseeker/user/${uniqueNumber}`)
          .then((response) => {
            setUser(response.data);
            setLoading(false);
          })
          .catch((err) => {
            setError('Failed to load user data');
            setLoading(false);
          });
      })
      .catch((err) => {
        setError('Failed to find user by email');
        setLoading(false);
      });
  }, []);

  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const ageDifMs = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    if (!user) return;
    html2canvas(cardRef.current).then((canvas) => {
      const link = document.createElement('a');
      link.download = `${user.firstName}_${user.lastName}_IDCard.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!user) return <div>No user data available</div>;

  const age = calculateAge(user.dateOfBirth);
  const stateOfOrigin = user.state || 'N/A';
  const profilePicture = user.avatar || 'https://via.placeholder.com/150';
  const profession = user.job || user.jobDecision || 'N/A';
  const dateCreated = user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A';
  const tin = user.TIN || 'N/A';
  const uniqueNumber = user.uniqueNumber;

  const qrValue = `https://ejobs.com.ng/user/${uniqueNumber}`; 

  return (
    <div className="flex flex-col items-center p-4">
      <div
        ref={cardRef}
        className="w-96 bg-white shadow-lg rounded-lg overflow-hidden border-2 border-blue-500 p-4"
      >
        <div className="bg-blue-500 text-white text-center py-2">
          <h2 className="text-xl font-bold">EJOB ID Card</h2>
        </div>
        <div className="flex flex-col items-center mt-4">
          <img
            src={profilePicture}
            alt="Profile"
            className="w-24 h-24 rounded-full border-2 border-blue-500 object-cover"
          />
          <h3 className="text-lg font-semibold mt-2">
            {user.firstName} {user.lastName}
          </h3>
          <p className="text-sm text-gray-600">{profession}</p>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
          <div>
            <span className="font-bold">Age:</span> {age}
          </div>
          <div>
            <span className="font-bold">Gender:</span> {user.gender || 'N/A'}
          </div>
          <div>
            <span className="font-bold">State of Origin:</span> {stateOfOrigin}
          </div>
          <div>
            <span className="font-bold">TIN:</span> {tin}
            
          </div>
          <div>
           
        
          </div>
          <div className="col-span-2">
            <span className="font-bold">Unique Number:</span> {uniqueNumber}
          </div>
     
         
          <div className="col-span-2">
            <span className="font-bold">Date Created:</span> {dateCreated}
          </div>
        </div>
        <div className="mt-4 flex justify-center">
          <QRCodeCanvas value={qrValue} size={128} />
        </div>
        <div className="text-center text-xs text-gray-500 mt-4">
          Scan QR for details
        </div>
      </div>
      <div className="mt-4 flex space-x-4">
        <button
          onClick={handlePrint}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Print ID Card
        </button>
        <button
          onClick={handleDownload}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          Download ID Card
        </button>
      </div>
    </div>
  );
};

export default DigitalIDCard;